var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card"},[_c('v-card-text',{staticClass:"pa-3"},[_c('line-chart',{attrs:{"data":_vm.data,"xtitle":"Time","ytitle":"Site Views","dataset":{borderWidth: 3}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }